module.exports = __webpack_public_path__ + "img/calc_off.89ca38f9.svg";